export const EXPERIMENT_FLAG = 'mccerts-1485_catalog-personalization-quiz_v1'

export type QuizBucket = 'control' | 'variant_1'

export const ELIGIBLE_SLUGS = [
  'ai-fundamentals-think-create-and-work-smarter',
  'lead-with-ai-adapt-implement-transform-your-organization',
  'leadership-and-decision-making-under-pressure',
  'negotiate-to-win-essentials-for-leaders',
  'strategic-communication-build-trust-drive-decisions-lead-with-influence',
  'breakthrough-innovation-strategy-from-bold-idea-to-business-impact',
] as const

export type EligibleSlug = (typeof ELIGIBLE_SLUGS)[number]

export const isEligibleSlug = (slug: string): slug is EligibleSlug =>
  (ELIGIBLE_SLUGS as readonly string[]).includes(slug)
